import { render, staticRenderFns } from "./chinese.vue?vue&type=template&id=4a1bcd22&scoped=true&"
import script from "./chinese.vue?vue&type=script&lang=js&"
export * from "./chinese.vue?vue&type=script&lang=js&"
import style0 from "./chinese.vue?vue&type=style&index=0&id=4a1bcd22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bcd22",
  null
  
)

export default component.exports